import User from '@api/User'
import FormEditUser from '@components/form/user/FormEditUser'
import FormEditUserPassword from '@components/form/user/FormEditUserPassword'
import LoadingPage from '@components/loading/LoadingPage'
import PageLayout from '@components/page/PageLayout'
import { Paper, Text } from '@mantine/core'
import PageNotFound404 from '@pages/PageNotFound404'
import { useParams } from 'react-router-dom'

const EditUser = () => {
    const params = useParams()
    const user_id = params.user_id
    const { isLoading, isError, data, isRefetching } = User.useGetUserByID({
        user_id: user_id!,
    })
    if (isLoading || isRefetching) {
        return <LoadingPage />
    }
    if (isError || data === undefined) {
        return (
            <PageNotFound404
                label='กลับไปหน้าผู้ใช้งานทั้งหมด'
                url='/lecturers'
            />
        )
    }
    return (
        <PageLayout pageTitle='แก้ไขผู้ใช้งานระบบ'>
            <Paper withBorder shadow='md' radius='md' p='md'>
                <Text mb='md' fw='bold'>
                    แก้ไขข้อมูล
                </Text>
                <FormEditUser data={data} />
            </Paper>
            <Paper withBorder shadow='md' radius='md' mt='md' p='md'>
                <Text mb='md' fw='bold'>
                    แก้ไขรหัสผ่าน
                </Text>
                <FormEditUserPassword data={data} />
            </Paper>
        </PageLayout>
    )
}

export default EditUser
